import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { SubSink } from 'subsink2';
import { ViewColumnComponent } from '../../../../view-column.component';
import { AgingPeriodFacade } from "../../facades/aging-period.facade";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AgingPeriodStates } from '../../aging-period-controller/states';
import { AgingPeriodActions } from '../../aging-period-controller/actions';
import {
  AgingPeriodContainerModel
} from 'blg-akaun-ts-lib';
import { Store } from "@ngrx/store";
import * as moment from 'moment';

interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  deactivateList: boolean;
  selectedIndex: number;
}

@Component({
  selector: 'app-aging-period-create',
  templateUrl: './aging-period-create.component.html',
  styleUrls: ['./aging-period-create.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})
export class AgingPeriodCreateComponent extends ViewColumnComponent {
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(state => state.deactivateReturn);
  readonly selectedIndex$ = this.componentStore.select(state => state.selectedIndex);
  createMainForm: FormGroup;
  prevIndex: number;
  @ViewChild(MatTabGroup, { static: true }) matTab: MatTabGroup;

  protected subs = new SubSink();
  protected compName = 'Aging Period Create';
  protected index = 1;
  protected localState: LocalState;
  protected prevLocalState: any;
  form;
  showNumMonth = false;
  constructor(
    private store: Store<AgingPeriodStates>,
    private viewColFacade: AgingPeriodFacade,
    private readonly componentStore: ComponentStore<LocalState>) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.viewColFacade.prevIndex$.subscribe(resolve => this.prevIndex = resolve);
    this.subs.sink = this.viewColFacade.prevLocalState$().subscribe(resolve => this.prevLocalState = resolve);
    this.subs.sink = this.localState$.subscribe(a => {
      this.localState = a;
      this.componentStore.setState(a);
    });
    this.form = new FormGroup({
      num_months: new FormControl(''),
      name: new FormControl('', Validators.required),
      period_type: new FormControl('', Validators.required)
    });
  }


  onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateReturn: false,
      deactivateAdd: false,
      deactivateList: false
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  onCreate() {
    const container = new AgingPeriodContainerModel();
    container.bl_fi_aging_period_hdr.code = moment().format('YYYY-MM-DD HH:mm:ss');
    container.bl_fi_aging_period_hdr.name = this.form.value.name;
    container.bl_fi_aging_period_hdr.period_type = this.form.value.period_type;
    container.bl_fi_aging_period_hdr.type = "DEBTOR";
    if(this.form.value.period_type==='MONTH'){
      container.bl_fi_aging_period_hdr.type = this.form.value.num_months;
    }
    this.store.dispatch(AgingPeriodActions.createInit({ container }));
  }

  disableButton() {
    return this.form.invalid;
  }

  onSelectType(e){
    if(e==="MONTH"){
      this.showNumMonth = true;
      this.form.get('num_month')?.setValidators([Validators.required, Validators.min(1)]);
    }else{
      this.showNumMonth = false;
      this.form.get('num_month')?.clearValidators();
    }
    this.form.get('num_month')?.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
